interface OllamaResponse {
  model: string;
  response: string;
  done: boolean;
}

export const generateResponse = async (prompt: string): Promise<string> => {
  try {
    const response = await fetch('http://localhost:11434/api/generate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: 'mistral',
        prompt,
        stream: false,
        options: {
          temperature: 0.7,
          top_p: 0.9,
        }
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to get response from Ollama');
    }

    const data: OllamaResponse = await response.json();
    
    // Ensure we have a response
    if (!data.response || typeof data.response !== 'string') {
      throw new Error('Invalid response format from Ollama');
    }

    return data.response.trim();
  } catch (error) {
    console.error('Error calling Ollama:', error);
    throw error;
  }
}; 